import { ISignOutResult } from '../../models/login/signout-result';
import { ApiService } from '../../services/data/api.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
@Injectable()
export class SignOutService {
    public error: any;
    public hasError: boolean;
    public signOutResult: ISignOutResult;///*, "$q"*/];

    constructor(public apiService: ApiService/*, public q: angular.IQService*/) {
    }
    public signOut(): Observable<ISignOutResult> {
        return this.apiService.get<ISignOutResult>(`api/signOut/SignOut`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    private handleError(error) {
        this.hasError = true;
        let msg = `Status Code ${error.status} on url ${error.url}`;
        console.error(msg);
        return throwError(() => error);
    }
}